module.exports = __webpack_public_path__ + "static/sieben-stadte-der-liebe-02-5c01cb36b08bf9b32b200469142c330e.jpg";